//健康监测模块的常量定义
'use strict';

import { versionCompare } from '@/Common/libs/utils';
// import _ from 'lodash';

//设备类型
let DEVICE_TYPE;
(function (types) {
  types[(types['UNKNOWN'] = 0)] = 'unknown';
  types[(types['ENCODE'] = 1)] = 'encoding_device';
  types[(types['SECURITY'] = 2)] = 'security_control';
  types[(types['TALKBACK'] = 3)] = 'talkback';
  types[(types['ACCESS'] = 4)] = 'access_control';
  types[(types['DOORBELL'] = 5)] = 'doorbell';
  types[(types['CLOUDBOX'] = 6)] = 'cloud_box';
  types[(types['THERMAL'] = 7)] = 'thermal_camera';
  types[(types['SWITCH'] = 8)] = 'HPP-web_network_device_title'; //--fix 网络设备，这里取名switch不太合理，这里包括交换机和AC设备
  types[(types['OTHERS'] = 9)] = 'HPP-web_site_device_other';
})(DEVICE_TYPE || (DEVICE_TYPE = {}));

//编码设备类型
let ENCODE_DEVICE_TYPE;
(function (types) {
  types[(types['NONE'] = 0)] = 'none';
  types[(types['IPC'] = 1)] = 'ipc'; //前端设备
  types[(types['NVR'] = 2)] = 'nvr'; //--fix 后端设备，这里取名NVR不太合理，这里包括NVR和DVR
  types[(types['IPDOME'] = 3)] = 'ipdome'; // 球机
  types[(types['THERMAL'] = 6)] = 'thermal_camera'; // 热成像
})(ENCODE_DEVICE_TYPE || (ENCODE_DEVICE_TYPE = {}));

//详细设备类型
let DETAIL_DEVICE_TYPE;
(function (types) {
  types[(types['UNKNOWN'] = 0)] = 'unknown';
  types[(types['NVR'] = 1)] = 'nvr';
  types[(types['DVR'] = 2)] = 'dvr';
  types[(types['AX2'] = 3)] = 'ax2';
  types[(types['AXHUB'] = 4)] = 'alarm';
  types[(types['AXHYB'] = 5)] = 'alarm'; // 混合报警主机
  types[(types['AXBOX'] = 6)] = ''; // 报警盒
  types[(types['AXCASE'] = 7)] = ''; // 报警箱
  types[(types['AXCOLUMN'] = 8)] = ''; // 报警柱
  types[(types['AX_HYBRID_PRO'] = 10)] = 'axHybridPro'; // 报警柱
  types[(types['SOLAR_ENNERGY'] = 11)] = 'ipc'; // 太阳能相机
  types[(types['RADAR'] = 13)] = 'radar'; // 跌倒雷达
})(DETAIL_DEVICE_TYPE || (DETAIL_DEVICE_TYPE = {}));

//设备排序优先级
let DEVICE_PRIORITY;
(function (priority) {
  priority[DEVICE_TYPE.ENCODE] = 1;
  priority[DEVICE_TYPE.ACCESS] = 2;
  priority[DEVICE_TYPE.SECURITY] = 3;
  priority[DEVICE_TYPE.TALKBACK] = 4;
  priority[DEVICE_TYPE.UNKNOWN] = 5;
})(DEVICE_PRIORITY || (DEVICE_PRIORITY = {}));

//设备图标
let DEVICE_LOGO;
(function (logo) {
  logo[DEVICE_TYPE.UNKNOWN] = '';
  logo[DEVICE_TYPE.ENCODE] = 'icon-encode_';
  logo[DEVICE_TYPE.SECURITY] = 'icon-alarm_host_';
  logo[DEVICE_TYPE.TALKBACK] = 'icon-talk_back_';
  logo[DEVICE_TYPE.ACCESS] = 'icon-access_control_';
  logo[DEVICE_TYPE.DOORBELL] = 'icon-health_state_all_site_doorbell_';
  logo[DEVICE_TYPE.CLOUDBOX] = 'icon_video_cloud_';
  logo[DEVICE_TYPE.SWITCH] = 'icon-icon_Site_switch_';
  logo[DEVICE_TYPE.OTHERS] = 'icomoon-icon_other_more_device_x_24_';
})(DEVICE_LOGO || (DEVICE_LOGO = {}));

//网络状态
let NET_STATUS;
(function (status) {
  status[(status['ONLINE'] = 1)] = 'online';
  status[(status['OFFLINE'] = 0)] = 'offline';
})(NET_STATUS || (NET_STATUS = {}));

let BATTERY_STATUS;
(function (status) {
  status['NOT_SUPPORT'] = 0; //不支持获取
  status['NORMAL'] = 1; //正常
  status['ABNORMAL'] = 2; //电量低
  status['N0_BATTERY'] = 3; //未安装电池
})(BATTERY_STATUS || (BATTERY_STATUS = {}));

let HDD_STATUS;
(function (status) {
  status[(status['UNKNOWN'] = 0)] = 'unknown'; //未知
  status[(status['IPC_NODISK_NORMAL'] = 1)] = 'no_sdcard'; //IPC 无SD卡
  status[(status['IPC_DISK_NORMAL'] = 2)] = 'normal'; //IPC SD卡正常
  status[(status['IPC_DISK_FULL'] = 3)] = 'sdcard_full'; // IPC SD卡满
  status[(status['IPC_DISK_ABNORMAL'] = 4)] = 'sdcard_exception'; //IPC SD卡异常
  status[(status['NVR_NDISK_FULL'] = 5)] = 'disk_full'; //NVR HDD满
  status[(status['NVR_NODISK_ABNORMAL'] = 6)] = 'diskless'; //NVR 无盘
  status[(status['NVR_DISK_ABNORMAL'] = 7)] = 'hdd_exception'; //NVR HDD异常
  status[(status['NVR_DISK_NORMAL'] = 8)] = 'normal'; //NVR 正常
  status[(status['BALL_DISK_FULL'] = 9)] = 'sdcard_full'; //球机SD卡满
  status[(status['BALL_DISK_ABNORMAL'] = 10)] = 'sdcard_exception'; //球机SD卡异常
  status[(status['BALL_NODISK_NORMAL'] = 11)] = 'no_sdcard'; //球机无SD卡
  status[(status['BALL_DISK_NORMAL'] = 12)] = 'normal'; //SD卡正常
  status[(status['TGP_NODISK_NORMAL'] = 13)] = 'no_sdcard'; //热成像无盘
  status[(status['TGP_DISK_NORMAL'] = 14)] = 'normal'; //热成像磁盘正常
  status[(status['TGP_DISK_FULL'] = 15)] = 'sdcard_full'; //热成像磁盘满
  status[(status['TGP_DISK_ABNORMAL'] = 16)] = 'sdcard_exception'; //热成像磁盘出错
})(HDD_STATUS || (HDD_STATUS = {}));

//注册门口机的状态
let GATE_MACHINE_STATUS;
(function (status) {
  status[(status['SUCCESS'] = 1)] = 'success';
  status[(status['FAILURE'] = 0)] = 'failure';
})(GATE_MACHINE_STATUS || (GATE_MACHINE_STATUS = {}));

//外接电源状态
let POWER_LINK_STATUS;
(function (status) {
  status[(status['NO_SUPPORT'] = 0)] = 'not_support';
  status[(status['CONNECT'] = 1)] = 'normal';
  status[(status['DISCONNECT'] = 2)] = 'disconnect';
})(POWER_LINK_STATUS || (POWER_LINK_STATUS = {}));

//移动网络状态
let MOBILE_STATUS;
(function (status) {
  status[(status['NO_SUPPORT'] = 0)] = 'not_support';
  status[(status['CONNECT'] = 1)] = 'normal';
  status[(status['DISCONNECT'] = 2)] = 'disconnect';
})(MOBILE_STATUS || (MOBILE_STATUS = {}));

//WIFI状态
let WIFI_STATUS;
(function (status) {
  status[(status['NO_SUPPORT'] = 0)] = 'not_support';
  status[(status['CONNECT'] = 1)] = 'normal';
  status[(status['DISCONNECT'] = 2)] = 'disconnect';
})(WIFI_STATUS || (WIFI_STATUS = {}));

//有线网络状态
let WIRED_STATUS;
(function (status) {
  status[(status['NO_SUPPORT'] = 0)] = 'not_support';
  status[(status['CONNECT'] = 1)] = 'normal';
  status[(status['DISCONNECT'] = 2)] = 'disconnect';
  status[(status['IPERROR'] = 3)] = 'ip_conflict';
})(WIRED_STATUS || (WIRED_STATUS = {}));

//子系统类型
let SUBSYSTEM_TYPE;
(function (type) {
  type[(type['PLAIN'] = 0)] = 'plain';
  type[(type['PUBLIC'] = 1)] = 'public';
})(SUBSYSTEM_TYPE || (SUBSYSTEM_TYPE = {}));

//布防状态
let DEFENCE_STATUS;
(function (status) {
  status[(status['NOT_SUPPORT'] = 0)] = 'unsupported';
  status[(status['STAY_ARMED'] = 1)] = 'action_30001';
  status[(status['DISARMING'] = 2)] = 'disarming';
  status[(status['ARMING'] = 3)] = 'defencing';
  status[(status['AWAY_ARMED'] = 4)] = 'action_30002';
})(DEFENCE_STATUS || (DEFENCE_STATUS = {}));

//防区状态
let ALARM_INPUT_STATUS;
(function (status) {
  status['ALARM_NOT_SUPPORT'] = 0; //不支持获取
  status['ALARM_NOT'] = 1; //正常
  status['ALARM'] = 2; //产生报警

  status['BYPASS_NOT_SUPPORT'] = 0; //不支持获取
  status['BYPASS'] = 1; //旁路
  status['BYPASS_NOT'] = 2; //非旁路

  status['BATTERY_NO_SUPPORT'] = 0; //不支持获取
  status['BATTERY_NORMAL'] = 1; //正常
  status['BATTERY_LOW'] = 2; //低电量

  status['FAULT_NOT_SUPPORT'] = 0; //不支持获取
  status['FAULT_NOT_LINK'] = 1; //未关联
  status['FAULT_ONLNE'] = 2; //在线
  status['FAULT_OFFLINE'] = 3; //离线
  status['FAULT_TRIGGER'] = 4; //被触发
  status['FAULT'] = 5; //故障
  status['FAULT_HEART_EXCEPTION'] = 6; //心跳异常

  status['TAMPER_NOT_SUPPORT'] = 0; //不支持获取
  status['TAMPER_NOT'] = 1; //非防拆
  status['TAMPER'] = 2; //防拆

  status['WIRED_NOT_SUPPORT'] = 0; //不支持获取
  status['WIRED'] = 1; //有线
  status['WIREDLESS'] = 2; // 无线

  status['SIGNAL_NOT_SUPPORT'] = 0; // 不支持信号获取
  status['SIGNAL_SUPPORT'] = 1; // 支持信号获取

  status['POWER_NOT'] = 0; // 扩展模块交流电连接
  status['POWER_NOT_CONNECT'] = 1; // 扩展模块交流电掉电
  status['POWER_CONNECT'] = 2; // 扩展模块交流电连接
})(ALARM_INPUT_STATUS || (ALARM_INPUT_STATUS = {}));

//外设类型
let ACCESSORY_TYPE;
(function (type) {
  type[(type['OUTPUT'] = 0)] = 'external_output'; //输出
  type[(type['KEYBOARD'] = 1)] = 'external_keyboard'; //键盘
  type[(type['LIGHT'] = 2)] = 'external_alarm'; //警号
  type[(type['CARD_READER'] = 3)] = 'external_wireless_card_reader'; //无线读卡器
  type[(type['RECEIVE'] = 4)] = 'external_wireless_receive'; //无线接收器
  type[(type['ZONE_MODEL'] = 5)] = 'external_zone_model'; //防区模块
  type[(type['RELAY'] = 6)] = 'name_alarm_relay'; //继电器
  type[(type['REPEATER'] = 7)] = 'external_repeater'; //中继器
  type[(type['TRANSMITTER'] = 8)] = 'external_transmitter'; //变送器
  type[(type['MULTIPLEXER'] = 9)] = 'name_alarm_multiplexer'; //多路发射机
  type[(type['REMOTE_CONTROL'] = 10)] = 'name_alarm_remote_control'; //遥控器
})(ACCESSORY_TYPE || (ACCESSORY_TYPE = {}));
//输出外设-子类型
let ACCESSORY_SUBTYPE;
(function (type) {
  type[(type['UNKNOWN'] = 0)] = 'unknown'; //继电器
  type[(type['RELAY'] = 1)] = 'relay_output'; //继电器
  type[(type['SWITCH'] = 2)] = 'wall_switch'; //墙装开关
  type[(type['SOCKET'] = 3)] = 'smart_socket'; //智能插座
  type[(type['LCDKEYBOARD'] = 4)] = 'lcd_keyboard'; //lcd键盘
  type[(type['INTERCOM'] = 5)] = 'external_alarm'; //对讲警号
})(ACCESSORY_SUBTYPE || (ACCESSORY_SUBTYPE = {}));

//外设图标
let ACCESSORY_LOGO;
(function (logo) {
  logo[ACCESSORY_TYPE.OUTPUT] = 'icomoon-img_output_module_online';
  logo[ACCESSORY_TYPE.KEYBOARD] = 'icomoon-img_keyboard_online';
  logo[ACCESSORY_TYPE.LIGHT] = 'icomoon-img_warning_signal_online';
  logo[ACCESSORY_TYPE.CARD_READER] = 'icomoon-img_card_reader_online';
  logo[ACCESSORY_TYPE.RECEIVE] = 'icomoon-img_wireless_receiver_online';
  logo[ACCESSORY_TYPE.ZONE_MODEL] = 'icomoon-img_alarm_input_online';
  logo[ACCESSORY_TYPE.RELAY] = 'icomoon-relay_nor';
  logo[ACCESSORY_TYPE.REPEATER] = 'icomoon-icon_repeater';
  logo[ACCESSORY_TYPE.TRANSMITTER] = 'icomoon-tree_transmitter_nor';
})(ACCESSORY_LOGO || (ACCESSORY_LOGO = {}));

let ACCESSORY_SUBTYPE_LOGO;
(function (logo) {
  logo[ACCESSORY_SUBTYPE.RELAY] = 'icomoon-relay_nor';
  logo[ACCESSORY_SUBTYPE.SWITCH] = 'icomoon-switch_wall_nor';
  logo[ACCESSORY_SUBTYPE.SOCKET] = 'icomoon-smart_socket_nor';
  logo[ACCESSORY_SUBTYPE.LCDKEYBOARD] = 'icomoon-tree_lcd_keyboard_nor';
  logo[ACCESSORY_SUBTYPE.INTERCOM] = 'icomoon-alarm_speak_nor';
})(ACCESSORY_SUBTYPE_LOGO || (ACCESSORY_SUBTYPE_LOGO = {}));

//外设状态
let ACCESSORY_STATUS;
(function (status) {
  status['BATTERY_NOT_SUPPORT'] = 0; //不支持获取
  status['BATTERY_NORMAL'] = 1; //正常
  status['BATTERY_LOW'] = 2; //电量低
  status['STATUS_NOT_SUPPORT'] = 0; //不支持获取
  status['BATTERY_LOSS'] = 3; //蓄电池缺失
  status['STATUS_NOT_LINK'] = 1; //未关联
  status['STATUS_ONLINE'] = 2; //在线
  status['STATUS_OFFLINE'] = 3; //离线
  status['STATUS_HEART_EXCEPTION'] = 4; //心跳异常
  status['SIGNAL_SUPPORT'] = 1; //支持信号强度
  status['SIGNAL_NOT_SUPPORT'] = 0; //不支持信号强度
  status['WIRE_NOT_SUPPORT'] = 0; //不支持区分
  status['WIRED'] = 1; //有线
  status['WIRELESS'] = 2; //无线
})(ACCESSORY_STATUS || (ACCESSORY_STATUS = {}));

//信号强度
//0（无）、1~29（弱）、30~79（中）、80~100（强）
let SIGNAL_LEVEL;
(function (level) {
  level['NONE'] = 0;
  level['WEAK'] = 1 * 2.55;
  level['MID'] = 30 * 2.55;
  level['STRONG'] = 80 * 2.55;
})(SIGNAL_LEVEL || (SIGNAL_LEVEL = {}));

//是否开启EN认证
let EN_IDENTIFY;
(function (status) {
  status['UNOPEN'] = 0;
  status['OPEN'] = 1;
  status['UNKNOWN'] = 2;
})(EN_IDENTIFY || (EN_IDENTIFY = {}));

//EN认证是否成功
let EN_IDENTIFY_RESULT;
(function (status) {
  status['FAILURE'] = 0;
  status['SUCCESS'] = 1;
})(EN_IDENTIFY_RESULT || (EN_IDENTIFY_RESULT = {}));

//站点状态
let SITE_STATUS;
(function (status) {
  status['OWNED_BY_INSTALLER'] = 0; //刚创建时托管状态
  status['OWNER_BY_END_USER'] = 1; //转移后
  status['DELEGATE_TO_INSTALLER'] = 2; //托管中
  status['CANCLE_SITE_TRUSTEESHIP'] = 3; //取消托管
  status['TRUSTEESHIP_APPLYING'] = 4; //申请托管
  status['TRUSTEESHIP_APPLY_FAILED'] = 5; //申请失败
})(SITE_STATUS || (SITE_STATUS = {}));

//通道类型
let CHANNEL_TYPE;
(function (status) {
  status['UNKNOWN'] = 0;
  status['SIMULATION_CHANNEL'] = 1;
  status['IP_CHANNEL'] = 2;
})(CHANNEL_TYPE || (CHANNEL_TYPE = {}));

//报警主机布撤防状态
let ARM_STATUS;
(function (status) {
  status['ARMED'] = 0;
  status['DISARMED'] = 1;
})(ARM_STATUS || (ARM_STATUS = {}));

//硬盘运行状态
let HARD_DISK_STATUS;
(function (status) {
  status['SELF_DETECT_STATE_NORMAL'] = 0; //自检评估正常
  status['SELF_DETECT_STATE_ERROR'] = 1; //自检评估异常
  status['OVERALL_STATE_FUNCTIONAL'] = 0; //整体评估正常
  status['OVERALL_STATE_BADSECTORS'] = 1; //整体评估扇区损坏
  status['OVERALL_STATE_FAULT'] = 2; //整体评估故障
})(HARD_DISK_STATUS || (HARD_DISK_STATUS = {}));

//门铃SD卡状态
let DOORBELL_SD_STATUS;
(function (status) {
  status[(status['EXCEPTION'] = 0)] = 'exception';
  status[(status['NORMAL'] = 1)] = 'normal';
  status[(status['NO_DISK'] = 2)] = 'no_sdcard';
})(DOORBELL_SD_STATUS || (DOORBELL_SD_STATUS = {}));

//循环录像开启状态
let CIRCULAR_RECORD_STATUS;
(function (status) {
  status[(status['NOT_REPORTED'] = -1)] = 'not_reported';
  status[(status['UNOPRN'] = 0)] = 'unopened';
  status[(status['OPEN'] = 1)] = 'opened';
})(CIRCULAR_RECORD_STATUS || (CIRCULAR_RECORD_STATUS = {}));

//视频信号状态
let VIDEO_SIGNAL_STATUS;
(function (status) {
  status[(status['NONE'] = 0)] = 'none'; //不涉及
  status[(status['NORMAL'] = 1)] = 'normal'; //正常
  status[(status['VIDEO_LOSS'] = 2)] = 'video_loss'; //丢失
})(VIDEO_SIGNAL_STATUS || (VIDEO_SIGNAL_STATUS = {}));

//机箱状态
let CASE_STATUS;
(function (status) {
  status[(status['NOT_SUPPORT'] = 0)] = 'not_support';
  status[(status['OPEN'] = 1)] = 'open';
  status[(status['CLOSE'] = 2)] = 'close';
})(CASE_STATUS || (CASE_STATUS = {}));

//设备ISAPI支持状态
let ISAPI_SUPPORT;
(function (status) {
  status['UNKNOWN'] = 0; //未知
  status['DETECTING'] = 1; //探测中
  status['NOT_SUPPORT'] = 2; //不支持
  status['SUPPORT'] = 3; //支持
  status['DEVICE_VERSION_LOW'] = 4; //设备版本较低
})(ISAPI_SUPPORT || (ISAPI_SUPPORT = {}));

//设备接入类型
let ACCESS_TYPE;
(function (status) {
  status['P2P'] = 0;
  status['HIK_DDNS'] = 1;
  status['IP_DOMAIN'] = 2;
  status['CLOUD_PROXY'] = 3;
})(ACCESS_TYPE || (ACCESS_TYPE = {}));

let HIKDDNS_STATUS;
(function (status) {
  status['UNOPEN'] = 0;
  status['OPEN'] = 1;
})(HIKDDNS_STATUS || (HIKDDNS_STATUS = {}));

//云存储盒子关联状态
let RELATE_STATUS;
(function (status) {
  status['UNRELATED'] = 0;
  status['RELATED'] = 1;
})(RELATE_STATUS || (RELATE_STATUS = {}));

//设备状态
let DEVICE_STATUS;
(function (status) {
  status['UNKNOWN'] = 0; //未知
  status['LOGINING'] = 1; //登录中
  status['LOGIN_SUCCESS'] = 2; //登录成功
  status['USER_PASS_ERROR'] = 3; //用户名密码错误
  status['CONNECT_FAIL'] = 4; //连接失败
  status['DEVICE_TYPE_NOT_MATCH'] = 5; //设备大类不匹配
  status['IP_LOCKED'] = 6; //IP锁定
  status['UNALLOWED_OEM_DEVICE'] = 7; //不允许接入的OEM设备
})(DEVICE_STATUS || (DEVICE_STATUS = {}));

//设备来源
let DEVICE_SOURCE;
(function (status) {
  status['UNKNOWN'] = 0; //未知
  status['OEM'] = 1; //oem定制设备
  status['HIK'] = 2; //hik非定制设备
  status['EZVIZ'] = 3; //萤石设备
})(DEVICE_SOURCE || (DEVICE_SOURCE = {}));

/**
 * 采用老框架-门禁明眸
 */
const SMART_EYE = [
  'DS-K1T671M-3XF',
  'DS-K1T671TMW-3XF',
  'DS-K1T671TM-3XF',
  'DS-K1TA70MI-T',
  'DS-K1T341BMWI-T',
  'DS-K1T341BMI-T',
  'DS-K1T341M'
];
const checkSmartEye = function (model) {
  for (let item of SMART_EYE) {
    if (model === item) {
      return true;
    }
  }
  return false;
};

/**
 * 采用新框架-门禁明眸
 */
const SMART_EYE_NEW = [
  'DS-K1T671TMFW',
  'DS-K1T671TMF',
  'DS-K1T671TMW',
  'DS-K1T671TM',
  'DS-K1T671MFW',
  'DS-K1T671MF',
  'DS-K1T671MW',
  'DS-K1T671M',
  'DS-K1T672MW',
  'DS-K1T672M',
  'DS-K1T672E',
  'DS-K1T672DX-T',
  'DS-K1T672DWX-T',
  'DS-K5671-ZV',
  'DS-K5671-ZH',
  'DS-K5671-ZU',
  'DS-K5671-3XF/ZU',
  'DS-K5672MW-Z',
  'DS-K5604A-ZH',
  'DS-K5604A-ZV',
  'DS-K5604A-VI',
  'DS-K5604A-V',
  'DS-K5604A-W',
  'DS-K5604A-3XF/V',
  'DS-K1T640M',
  'DS-K1T641MF',
  'DS-K1T641M',
  'DS-K1T642EFW',
  'DS-K1T642EF',
  'DS-K1T642EW',
  'DS-K1T642E',
  'DS-K1T642MFW',
  'DS-K1T642MF',
  'DS-K1T642MW',
  'DS-K1T642M',
  'DS-K1T331W',
  'DS-K1T331',
  'DS-K1A330W',
  'DS-K1A330',
  'DS-K1T341AMF',
  'DS-K1T341AM',
  'DS-K1A340FWX',
  'DS-K1A340WX',
  'DS-K1A340FX',
  'DS-K1A340X',
  'DS-K1T343MFWX',
  'DS-K1T343MFX',
  'DS-K1T343MWX',
  'DS-K1T343MX',
  'DS-K1T343EFWX',
  'DS-K1T343EFX',
  'DS-K1T343EWX',
  'DS-K1T343EX',
  'DS-K1T673M',
  'DS-K1T673MW',
  'DS-K1T673MG',
  'DS-K1T673TMW',
  'DS-K1T673TMG',
  'DS-K1T673DX',
  'DS-K1T673DWX',
  'DS-K1T673TDX',
  'DS-K1T673TDWX',
  'DS-K1T673TDGX',
  // 这4款明眸设备是俄分基于DS-K1T331定制的设备，属于海康品牌区域定制
  'ACT-T1331',
  'ACT-T1331W',
  'ACT-T1341M',
  'ACT-T1341MF',
  // 以下几款1.8.x接入，软件功能复用343系列
  'DS-K1T342MX',
  'DS-K1T342MWX',
  'DS-K1T342MFWX',
  'DS-K1T342MFX',
  'DS-K1T342EX',
  'DS-K1T342EWX',
  'DS-K1T342EFWX',
  'DS-K1T342DX',
  'DS-K1T342DWX',
  // 以下几款1.10.0接入
  'DS-K1T680D-E1',
  'DS-K1T680DW',
  'DS-K1T680DG',
  'DS-K1T680DG1',
  'DS-K1T680DF-E1',
  'DS-K1T680DFW',
  'DS-K1T680DFG',
  'DS-K1T680DFG1',
  // 以下几款 融合云v1.11.0接入
  'DS-K5671B-ZH',
  'DS-K1T671BTM',
  'DS-K1T671BTM(2.8mm)',
  'DS-K1T671BTMY',
  'DS-K1T671BTMWY',
  'DS-K1T671BTMG',
  'DS-K1T671BTMGY',
  'DS-K1T671BTMF',
  'DS-K1T671BTMFY',
  'DS-K1T671BTMFW',
  'DS-K1T671BTMFWY',
  'DS-K1T671BM',
  'DS-K1T671BM(2.8mm)',
  'DS-K1T671BMY',
  'DS-K1T671BMF',
  'DS-K1T671BMFY',
  'DS-K1T671BMW',
  'DS-K1T671BMFW',
  'DS-K1T671BMG',
  'DS-K1T671BMI',
  'DS-K1T671BTMI',
  'DS-K5671B-ZHY',
  'DS-K5671B-ZU',
  'DS-K5671B-ZU(2.8mm)',
  'DS-K5671B-ZUY',
  'DS-K5671B-W',
  'DS-K5671B-WY',
  'DS-K5671B-ZV',
  'DS-K5671B-ZVY',
  'DS-K1T641AM',
  'DS-K1T641AMW',
  'DS-K1T641AMFW',
  'DS-K1T341CM',
  'DS-K1T341CMW',
  'DS-K1T341CMF',
  'DS-K1T341CMFW',
  'DS-K1T502DBWX', // 1.12.0 增加
  'DS-K1T502DBFWX', // 1.12.0 增加
  'DS-K1T502DBWX-C', // 1.12.0 增加
  'DS-K1T502DBFWX-C', // 1.12.0 增加
  // 2.0.100 新增
  'DS-K1T681DBX',
  'DS-K1T681DBWX'
];
const checkSmartEyeNew = function (model) {
  for (let item of SMART_EYE_NEW) {
    if (model === item) {
      return true;
    }
  }
  return false;
};

/**
 * 采用5.0新框架-门禁明眸  access5.0
 */
const ACCESS_5 = [
  // 2.2.0 新增
  'DS-K1T321MFWX',
  'DS-K1T321MWX',
  'DS-K1T321EFWX',
  'DS-K1T321EWX',
  'DS-K1T321MX',
  'DS-K1T321MFX',
  'DS-K1T321EX',
  'DS-K1T321EFX'
];
const checkACCESS5 = function (model) {
  for (let item of ACCESS_5) {
    if (model === item) {
      return true;
    }
  }
  return false;
};

/**
 * 判断是否为明眸门禁
 */
const isSmartEye = function (model) {
  return checkSmartEye(model) || checkSmartEyeNew(model) || checkACCESS5(model);
};

/**
 * 采用老框架-指纹门禁
 */
const FINGERPRINT = [
  'DS-K1T804AF',
  'DS-K1T804MF',
  'DS-K1T804EF',
  'DS-K1T804DF',
  'DS-K1T8003MF',
  'DS-K1T8003EF',
  'DS-K1T8003F'
];
const checkFingerprint = function (model) {
  for (let item of FINGERPRINT) {
    if (model === item) {
      return true;
    }
  }
  return false;
};

/**
 * 对讲设备不支持远程配置
 */
const TALKBACK_NOT_SUPPORT_REMOTE_CONFIG = [
  'DS-KH9310-WTE1',
  'DS-KH9510-WTE1',
  'DS-KH9310-WTE1(B)',
  'DS-KH9510-WTE1(B)'
];
const supportTalkbackRemoteConfig = function (model) {
  for (let item of TALKBACK_NOT_SUPPORT_REMOTE_CONFIG) {
    if (model === item) {
      return false;
    }
  }
  return true;
};

/**
 * 设备版本低于20170601，设备肯定不支持ISAPI协议透传，无法使用远程配置按钮
 */
const supportISAPIVersion = function (version) {
  if (version) {
    const deviceVersion = version.split(' ');
    if (parseInt(deviceVersion[2], 10) < 170601) {
      // 版本向SDK同事确认的
      return false;
    }
  }

  return true;
};

/**
 * nvr/dvr类型，通过白名单策略跳转到配置包Web5.0
 */
const getNvrDvrType = function (type, model, version) {
  if (type === 'nvs') {
    // 远程配置nvs传nvr
    type = 'nvr';
  }
  // 白名单里面强制Web5.0
  if (window['NVR_WEB_5.0']) {
    if (window['NVR_WEB_5.0'].includes(model)) {
      return `${type }_5.0`;
    }
  }

  // 白名单里面的强制返回Web4.0
  if (window['NVR_WEB_4.0']) {
    if (window['NVR_WEB_4.0'].includes(model)) {
      return type;
    }
  }

  /* Web5.0配置包启用逻辑
   * 获取设备的主控版本，如 V4.51.000 build 210622，程序中判断大于 V4.51.000 版本，采用web5.0；
   * 后端有简化菜单，采用的不是这个代码分支，可能会出现 V4.41.xx build 210730，那么版本判断已经无法满足条件了，会结合判断 build 日期，大于 210622 ，采用web5.0 （设备可能还是采用web4.0，这个风险存在，目前没有这样的版本，后续可能会有，但是不多，遇到小问题，立即修复更新）
   * Portal中增加排除型号处理，万一线上遇到web5.0无法兼容设备，只需要在配置文件中增加排除，就立即回到web4.0，算容错机制吧
   */

  // V4.51.025 build 210828
  if (['nvr', 'dvr'].includes(type) && version) {
    const deviceVersion = version.split(' ');
    if (versionCompare(deviceVersion[0], 'V4.51.000') >= 0 || parseInt(deviceVersion[2], 10) > 210622) {
      // 版本向王志海工确认的
      return `${type }_5.0`;
    }
  }

  return type;
};

/**
 * 报警盒、报警箱、报警柱不支持远程配置,21/09/26暂加入hybridpro
 */
const supportAlarmRemoteConfig = function (deviceSubType) {
  if (
    !_.isUndefined(deviceSubType)
    && (deviceSubType === DETAIL_DEVICE_TYPE['AXBOX']
      || deviceSubType === DETAIL_DEVICE_TYPE['AXCASE']
      || deviceSubType === DETAIL_DEVICE_TYPE['AXCOLUMN']
      || deviceSubType === DETAIL_DEVICE_TYPE['AX_HYBRID_PRO'])
  ) {
    return false;
  }
  return true;
};

let SITE_CHECKING_STATUS;
(function (status) {
  status[(status['NORMAL'] = 0)] = 'health_detection';
  status[(status['CHECKING'] = 1)] = 'diagnosising';
  status[(status['CHECKED'] = 2)] = 'diagnosis_complete';
})(SITE_CHECKING_STATUS || (SITE_CHECKING_STATUS = {}));

// 分享类型
const SHARE_TYPE = {
  NO_SHARE: 0,
  TO_OTHERS: 1,
  FROM_OTHERS: 2
};

// 分享的处理状态状态,
const SHARE_STATUS = {
  WAITING_USER: 0,
  WAITING_COMPONY: 1,
  SHARING: 2,
  END_USER: 3,
  END_COMPONY: 4
};

export {
  DEVICE_TYPE,
  ENCODE_DEVICE_TYPE,
  DEVICE_PRIORITY,
  DEVICE_LOGO,
  NET_STATUS,
  HDD_STATUS,
  BATTERY_STATUS,
  GATE_MACHINE_STATUS,
  POWER_LINK_STATUS,
  MOBILE_STATUS,
  WIFI_STATUS,
  WIRED_STATUS,
  DEFENCE_STATUS,
  ALARM_INPUT_STATUS,
  ACCESSORY_TYPE,
  ACCESSORY_STATUS,
  SUBSYSTEM_TYPE,
  SIGNAL_LEVEL,
  EN_IDENTIFY,
  EN_IDENTIFY_RESULT,
  SITE_STATUS,
  CHANNEL_TYPE,
  ARM_STATUS,
  ACCESSORY_LOGO,
  ACCESSORY_SUBTYPE_LOGO,
  HARD_DISK_STATUS,
  DOORBELL_SD_STATUS,
  CIRCULAR_RECORD_STATUS,
  VIDEO_SIGNAL_STATUS,
  CASE_STATUS,
  DETAIL_DEVICE_TYPE,
  ISAPI_SUPPORT,
  ACCESS_TYPE,
  HIKDDNS_STATUS,
  RELATE_STATUS,
  DEVICE_STATUS,
  DEVICE_SOURCE,
  SMART_EYE,
  checkSmartEye,
  SITE_CHECKING_STATUS,
  checkFingerprint,
  checkSmartEyeNew,
  checkACCESS5,
  isSmartEye,
  supportAlarmRemoteConfig,
  ACCESSORY_SUBTYPE,
  getNvrDvrType,
  SHARE_TYPE,
  SHARE_STATUS,
  supportTalkbackRemoteConfig,
  supportISAPIVersion
};
